import { useAuth as useClerkAuth } from '@clerk/clerk-react';

// ==============================|| AUTH HOOKS ||============================== //
//
// Compatibility shim: this hook used to return the JWTContext shape
// (`{ isLoggedIn, login, logout, register, ... }`). The app is now
// fully Clerk-backed; existing call sites mostly read `isLoggedIn`,
// so we expose Clerk's `isSignedIn` under both names. New code should
// import `useAuth` directly from `@clerk/clerk-react`.
//
// Legacy methods (login, logout, register, etc.) are not provided.
// Anything still calling those is dead code that needs to migrate
// to Clerk's `<SignIn>` / `<SignUp>` / `signOut()` UI components.

export default function useAuth() {
  const clerk = useClerkAuth();
  return {
    ...clerk,
    isLoggedIn: clerk.isSignedIn,
  };
}
